// Smooth scrolling has been removed. These helpers now perform instant jumps
// so existing call sites (Navbar, Hero, Footer, CostEstimator) keep working
// without any animation or Lenis runtime.

export function getLenis() {
  return null;
}

export function smoothScrollTo(target, options = {}) {
  const offset = typeof options?.offset === "number" ? options.offset : 0;

  if (typeof target === "number") {
    window.scrollTo({ top: target + offset, behavior: "auto" });
    return;
  }

  let el = null;
  if (typeof target === "string") {
    el = document.querySelector(target);
  } else if (target instanceof HTMLElement) {
    el = target;
  }

  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY + offset;
    window.scrollTo({ top, behavior: "auto" });
  }
}

// No-op hook kept for backwards compatibility with existing imports.
export default function useSmoothScroll() {}
